/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterGender_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectList_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterGender_itemSearch";
};
export type SbSharedRefineMenuFilterGender_itemSearch$data = SbSharedRefineMenuFilterGender_itemSearch;
export type SbSharedRefineMenuFilterGender_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterGender_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterGender_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterGender_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectList_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'b7386fe71e2a15dd5dbecaf542353699';
export default node;
